import React, {
  useState, useEffect,
} from 'react';
import { KatSpinner } from '@amzn/katal-react';
import { InView } from 'react-intersection-observer';

interface InfiniteScrollerProps {
  fetchPrevious: any;
  fetchNext: any;
  children: any;
  isPreviousLoading: boolean;
  isNextLoading: boolean;
  hasMore: boolean;
  hasPrevious: boolean;
  endMessage: string;
}

const InfiniteScroller: React.FC<InfiniteScrollerProps> = ({
  fetchPrevious,
  fetchNext,
  children,
  isPreviousLoading,
  isNextLoading,
  hasMore,
  hasPrevious,
  endMessage,
}) => {
  const [previousScroll, setPreviousScroll] = useState({
    height: 0,
    top: 0,
  });

  useEffect(() => {
    if (!isPreviousLoading && previousScroll.height > 0) {
      document.documentElement.scrollTop = previousScroll.top
      + (document.body.scrollHeight - previousScroll.height);
    }
  }, [isPreviousLoading]);

  const previousLoader = hasPrevious ? (
    <InView
      className="h-16"
      threshold={0}
      rootMargin="20px"
      onChange={(inView, entry) => {
        if (entry.isIntersecting) {
          setPreviousScroll({
            height: document.body.scrollHeight,
            top: document.documentElement.scrollTop,
          });
          fetchPrevious();
        }
      }}
    />
  ) : undefined;

  const nextLoader = hasMore ? (
    <InView
      className="h-16"
      threshold={0}
      rootMargin="20px"
      onChange={(inView, entry) => {
        if (entry.isIntersecting) {
          fetchNext();
        }
      }}
    />
  ) : (
    <div className="pt-4 pb-8 text-center text-sm italic">
      {endMessage}
    </div>
  );

  return (
    <>
      {
        isPreviousLoading ? (
          <div data-testid="previous-posts-spinner" className="h-16 text-center">
            <KatSpinner className="m-4" size="small" />
          </div>
        ) : previousLoader
      }
      {children}
      {
        isNextLoading ? (
          <div data-testid="next-posts-spinner" className="h-16 text-center">
            <KatSpinner className="m-4" size="small" />
          </div>
        )
          : nextLoader
      }
    </>
  );
};

export default InfiniteScroller;
